// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Page - Full Screen Layout */
.test-page-terms {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f8f9fa;
    padding: 20px;
}

/* Page Title */
.test-title-terms {
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
}

/* Container for the Terms Component */
.test-container-terms {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 600px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PdfViewer/TestTerms.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;AACjB;;AAEA,eAAe;AACf;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;AACpB","sourcesContent":["/* Test Page - Full Screen Layout */\n.test-page-terms {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    background-color: #f8f9fa;\n    padding: 20px;\n}\n\n/* Page Title */\n.test-title-terms {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 20px;\n}\n\n/* Container for the Terms Component */\n.test-container-terms {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
